import type { IPartnerSlim, IProfile } from "App/Modules/Models";
import { Permission } from "App/Modules/Models";

export const hasUserPermissionAnywhere = (profile: IProfile, permission: Permission) => {
    if (!profile) {
        return false;
    }
    return (
        !!profile.userPermissions?.partnerPermissions?.find((p) => p === permission) ||
        !!profile.userPermissions?.sitePermissions?.find((p) => p === permission)
    );
};

export const hasUserPermissionOnAnyPartner = (profile: IProfile, permission: Permission) => {
    if (!profile) {
        return false;
    }
    return !!profile.userPermissions?.partnerPermissions?.find((p) => p === permission);
};

export const hasUserAccessToMonitoring = (profile: IProfile) =>
    hasUserPermissionOnAnyPartner(profile, Permission.PartnerMonitoring) ||
    hasUserPermissionAnywhere(profile, Permission.SiteFunctionalConfiguration);

export const hasUserAccessToSiteInformation = (profile: IProfile) =>
    hasUserPermissionAnywhere(profile, Permission.SiteInformation);

export const hasUserAccessThroughSupportingPartner = (
    profile: IProfile,
    partner: IPartnerSlim,
    permission: Permission,
) => {
    // check if user has access through the same partner the site belongs to
    if (profile.partners.some((p) => p.id === partner.id) && hasUserPermissionAnywhere(profile, permission)) {
        return true;
    }

    // check if user has access through supporting partner
    if (
        partner.supportingPartnersSlim.some((sp) =>
            profile.partners.some(
                (p) =>
                    p.id === sp.parentPartnerId &&
                    sp.permissionsFromRole.includes(Permission[permission as unknown as keyof typeof Permission]) &&
                    hasUserPermissionAnywhere(profile, permission),
            ),
        )
    ) {
        return true;
    }

    // check if user has access to any site
    // This will cause problems where users who don't have access to a particular site but has correct permission somewhere else
    // will get a link to the site and will be presented with a 403 error when they click on it.
    // How do we solve this in the future?
    if (hasUserAccessToSiteInformation(profile)) {
        return true;
    }

    return false;
};
